import React, { useEffect, useRef, useState } from 'react';
import { useQuery } from '@apollo/client';
import AggregationCardsContainer from './AggregationCardsContainer';
import { getPageQuery, GET_PRODUCT_TYPES } from '../../services/querys';
import { buildMustFilters, getBrandIds } from './helpers';
import useGetIdsOnProducts from './hooks/use-get-ids-on-products';
import { DEFUALT_SORT } from './constants';

const ProductTypes = ({ featuredOnly, parent, urlTemplate, ...otherProps }) => {
  const counter = useRef(0);
  const [productTypes, setProductTypes] = useState([]);
  const { itemId: parentId, itemEntity } = parent;
  const { urlTemplateToUse } = otherProps;
  const { data: { pageData } = {}, loading: parentLoading } = useQuery(getPageQuery(itemEntity), {
    variables: { id: parentId },
    skip: !parentId
  });

  const brandIds = getBrandIds(pageData);

  const mustFilters = buildMustFilters(brandIds);

  const { aggsLoading, where, recordIds } = useGetIdsOnProducts({
    ...otherProps,
    mustFilters,
    parentLoading,
    featuredOnly,
    relationProperty: 'productTypeIds'
  });

  const { loading, refetch } = useQuery(GET_PRODUCT_TYPES, {
    variables: {
      where: where[counter.current],
      sort: DEFUALT_SORT
    },
    skip: parentLoading || aggsLoading || !where.length || where.length <= counter.current,
    onCompleted: data => {
      const newProductTypes = [...productTypes, ...data.productTypes];
      counter.current += 1;
      setProductTypes(newProductTypes);
    }
  });

  useEffect(() => {
    if (counter.current < where.length) {
      refetch({ where: where[counter.current], sort: DEFUALT_SORT });
    }
  }, [refetch, where]);

  if (loading || !productTypes || !productTypes.length) return null;

  let brandNames = [];
  if (
    // set brand names if the urlTemplate is relative and page doesn't have a parent
    (urlTemplate.startsWith('../') || !urlTemplate.startsWith('/')) &&
    urlTemplateToUse.split('/').length === 2
  ) {
    brandNames = pageData.brands && pageData.brands.map(brand => brand.name);
  }

  return (
    <AggregationCardsContainer
      {...otherProps}
      items={productTypes}
      recordIds={recordIds}
      brandNames={brandNames}
    />
  );
};

export default ProductTypes;
